const RelatedList = require('module/user/related_list')
const UserLocation = require('module/user/location')

const log = require('log').create('location_list') // eslint-disable-line

const LocationList = RelatedList.extend({

    id: 'locations',

    model: UserLocation,

})

module.exports = LocationList
